import React from 'react'

function Edit() {
    return (
        <div>
           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 6H11.3333V4.66667H14V3.33333H11.3333V2H10V6ZM4.66667 6V7.33333H2V8.66667H4.66667V10H6V6H4.66667ZM8.66667 12.6667V14H7.33333V10H8.66667V11.3333H14V12.6667H8.66667ZM2 12.6667V11.3333H6V12.6667H2ZM14 7.33333V8.66667H7.33333V7.33333H14ZM8.66667 3.33333H2V4.66H8.66667V3.33333Z" fill="#737B81"/>
</svg>
 
        </div>
    )
}

export default Edit
